import type { IControllerBridge, IInteractionStrategy } from './types';

/**
 * 编辑/表单模式策略
 * 编辑中：忽略多边形选中和绘制完成，不响应 moveend
 */
export class EditStrategy implements IInteractionStrategy {
  onSelect(): void {
    // 编辑中忽略多边形选中
  }

  onDrawComplete(): void {
    // 编辑中不触发绘制
  }

  onMoveEnd(): void {
    // 编辑中不响应 moveend
  }
}
